import { getCookie } from 'cookies-next'
import { create } from 'zustand'

type SelectedProjectStoreType = {
  selectedProjectId: string
  setSelectedProjectId: (e: string) => void

  modalOpened: boolean
  setModalOpened: (e: boolean) => void

  modalNotClosable: boolean
  setModalNotClosable: (e: boolean) => void
}

export const SELECTED_PROJECT_COOKIE_KEY = 'x-project'

export const useSelectedProjectStore = create<SelectedProjectStoreType>(
  set => ({
    modalOpened: false,
    setModalOpened: e => set(() => ({ modalOpened: e })),

    modalNotClosable: false,
    setModalNotClosable: e => set(() => ({ modalNotClosable: e })),

    selectedProjectId: getCookie(SELECTED_PROJECT_COOKIE_KEY) ?? '',
    setSelectedProjectId: e => set(() => ({ selectedProjectId: e }))
  })
)
